import React, { useCallback, useContext } from 'react'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import LineExclamationCircleIcon from 'components/Luxkit/Icons/line/LineExclamationCircleIcon'
import LineExclamationTriangleIcon from 'components/Luxkit/Icons/line/LineExclamationTriangleIcon'
import PrivateRequestFormModal from '../PrivateRequest/PrivateRequestFormModal'
import ModalContext from 'contexts/ModalContext'
import TextLink from 'components/Luxkit/TextLink'
import Group from 'components/utils/Group'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import RequestAgentCallbackModal from 'supportAssistant/components/RequestAgentCallback/Modals/RequestAgentCallbackModal'
import TextButton from 'components/Luxkit/Button/TextButton'
import ContactContext from 'contexts/contactContext'

interface Props {
  type: 'soldOut' | 'limited'
  variant: 'small' | 'medium' | 'large';
  offer: Tours.TourV2Offer
  hasPrivateRequest: boolean
  isPackageOptionTile?: boolean
}

function TourV2DepartureCta(props: Props) {
  const {
    type,
    offer,
    hasPrivateRequest,
    isPackageOptionTile = false,
    variant,
  } = props

  const supportContact = useContext(ContactContext)
  const contact = supportContact.defaultContact

  const callbacksFeatureEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.toursRequestAgentCallbackEnabled)

  const showModal = useContext(ModalContext)

  const handleCallbackClick = () => { showModal(<RequestAgentCallbackModal type="TOURS"/>) }

  const toggleModal = useCallback(() => {
    showModal(<PrivateRequestFormModal variations={offer.variations} tourId={offer.id} />)
  }, [showModal, offer])

  return <Group gap={12} desktopDirection="vertical" direction="vertical" fullWidth>
    {((isPackageOptionTile && type === 'soldOut') || (!isPackageOptionTile && type === 'soldOut')) &&
      <BodyTextBlock variant={variant} colour="neutral-two" startIcon={<LineExclamationCircleIcon/>}>
        This departure is sold out. {isPackageOptionTile ? 'Call us for more tour options.' : 'Try a different departure or call us for more tour options.'}
      </BodyTextBlock>
    }

    {((isPackageOptionTile && type === 'limited') || (!isPackageOptionTile && type === 'limited')) &&
      <BodyTextBlock variant={variant} colour="neutral-two" startIcon={<LineExclamationTriangleIcon/>}>
        This departure has <b>limited availability</b>. {isPackageOptionTile ? 'Call us for more options.' : 'Try a different departure or call us for more options.'}
      </BodyTextBlock>
    }
    <Group desktopDirection="horizontal-reverse" direction="vertical" gap={12} verticalAlign="center" horizontalAlign="center" desktopHorizontalAlign="space-between" fullWidth>

      <TextButton
        fit={isPackageOptionTile ? 'full-width' : 'mobile-full-width'}
        size="medium"
        kind="secondary"
        href={`tel:${contact.number}`}>
        Call on {contact.humanReadable}
      </TextButton>
      {callbacksFeatureEnabled && <TextLink
            size="medium"
            weight="bold"
            onClick={handleCallbackClick}
            startIcon={<LinePhoneIcon />}
          >
        Request a Callback
      </TextLink>
          }
      {hasPrivateRequest && <TextLink size={variant} weight="regular" onClick={toggleModal}>Request private departure</TextLink>}
    </Group>
  </Group>
}

export default TourV2DepartureCta
